import styled from 'styled-components'

const TwoStepPaymentFormHeaderUi = styled.div`
  display: flex;
`

export default TwoStepPaymentFormHeaderUi